import React, {useState} from "react";
import {Cascader, Tooltip} from "antd";
import {PlusCircleOutlined} from '@ant-design/icons';
import {getSystemId, hasCapability} from "@Utils";
import {GroupContext, QueryKeys, SystemContext} from "@Constants";
import {IRolePayload} from "@Models/IRoleDetails";
import {IGroupRoleDetails} from "@Models/IUserGroupDetails";
import appQueryClient from "@AppQueryClient";

interface ICascaderOptions {
    label: string;
    value: string;
    children?: ICascaderOptions[];
}

interface IProps {
    groupId?: string;
    roleAssignments?: IGroupRoleDetails[];
    userId: string;
    addAction: (roleId: string, groupId: string) => void;
    systemRolesOnly: boolean;
}

const RoleMenu: React.FC<IProps> = ({
    groupId, userId, addAction,
    roleAssignments, systemRolesOnly
}: IProps) => {
    const [options, setOptions] = useState<ICascaderOptions[]>([]);
    const rolesQuery = appQueryClient.getQueryData<IRolePayload>([QueryKeys.Roles]);

    const onDropdownVisibleChange = (open: boolean) => {
        if (!open) {
            return;
        }
        setOptions(getRoleOptions());
    };

    /**
     *  Get roles where capabilities allow and they don't currently exist for the user.
     */
    const getRoleOptions = () => {
        const roleOptions: ICascaderOptions[] = [];
        const currentRoles = roleAssignments?.map(x => x.roleId);
        const filteredRoles = rolesQuery?.roles?.filter(
            x => !currentRoles?.includes(x.roleId) && (systemRolesOnly ? 
                x.contextId === SystemContext : 
                x.contextId !== SystemContext));
        filteredRoles.forEach((role) => {
            if (hasCapability(
                "Role/Assign",
                role.contextId,
                role.contextId == SystemContext ? getSystemId() : (role.contextId == GroupContext ? groupId : userId))
            ) {
                roleOptions.push({
                    value: role.roleId,
                    label: role.name
                });
            }
        });
        return roleOptions;
    };

    return options?.length ? (
        <Tooltip title="Add role">
            <Cascader
                options={options}
                onDropdownVisibleChange={(value)=>{onDropdownVisibleChange(value);}}
                value={[]}
                onChange={(val) => addAction(val[0], groupId)}>
                <a href="#">
                    <PlusCircleOutlined/>
                </a>
            </Cascader>
        </Tooltip>
    ) : null;
};
export default RoleMenu;
